import React, { useState, forwardRef, useEffect } from 'react'
import Accordion from '../../../../components/Accordion/Accordion'
import FormCreator from '../../../../components/Forms/FormCreator'
import Buttons from '../../../../components/ui/button/Buttons'
import { CorporateInformationData } from './CorporateInformation.data'
import ButtonforValidate from './components/ButtonforValidate'
import { useStoreBase64ImageMutation } from '../../../../app/services/common/commonApi'
import { useCheckUENNumberExistOrNotMutation, useUpdateCorporateMemberDetailsByAdminMutation } from '../../../../app/services/corporateMembership/corporateMemberApi'
import ToastService from '../../../../services/toastService/ToastService'
import CenterModel from '../../../../components/ui/centerModel/CenterModel'
import { APIUrl } from '../../../../utils/API/fetchBaseQuery'
import SwalAlert from '../../../../services/swalService/SwalService'
import { hideGovernmentAgencyFields, hidePSPCFields, showGovernmentAgencyFields, showPSPCFields } from '../../utils/dropdownUtils'

const CorporateInformation = forwardRef((props, ref) => {
  const [formData, setFormData] = useState(CorporateInformationData);
  const [organisationLogo, setOrganisationLogo] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { error, success } = SwalAlert();
  const [companyUEN,setCompanyUEN] = useState(null)

  const [saveMainImage, { isSuccess: isSuccessImage, isLoading: isLoadingImage, data: profileImageUpload }] = useStoreBase64ImageMutation();
  const [updateCorporateMemberDetailsByAdmin, { data: updateCorporateMemberData, isLoading: updateCorporateMemberLoading, isError: updateCorporateMemberIsError, error: updateCorporateMemberError, }] = useUpdateCorporateMemberDetailsByAdminMutation();
  const [checkUENNumberExist, { data: checkUENNumberExistData, isLoading: checkUENNumberExistLoading, isError: checkUENNumberExistIsError, error: checkUENNumberExistError, }] = useCheckUENNumberExistOrNotMutation();


  const openModal = () => {
    setIsModalOpen(!isModalOpen)
  }

  const handleViewImage = () => {
    setIsModalOpen(true);
  }

  const handleClickValidate = () => {
    let companyUEN = ref?.current?.getFieldValue("UENNumber");
    if (companyUEN) {
      checkUENNumberExist({ CompanyUEN: companyUEN });
    }
  }

  const handleOrganazationImageUpload = async (data) => {
    const { base64Data, fileName } = data
    let saveFileRequest = {
      fileName: fileName,
      fileStr: base64Data,
      storagePath: "CompanyLogo",
    }
    const response = await saveMainImage(saveFileRequest)
    setOrganisationLogo(response.data.fileName);
  }

  const handleFormFieldChange = (dataField, value) => {
    let form = { ...formData };
    form.initialState = { ...form.initialState };
    let phoneNumberRegex = /^[0-9]+$/;
    if (["mainPhoneNumber", "billingContactNumber", "billingNumber"].includes(dataField)) {
      let isCheck = phoneNumberRegex.test(value)
      if (isCheck) {
        const updatedInitialState = { ...form.initialState, [dataField]: value }
        setFormData((prev) => ({ ...prev, ...form, initialState: { ...prev.initialState, ...updatedInitialState, }, }));
      } else {
        const updatedInitialState = { ...form.initialState, [dataField]: "" }
        setFormData((prev) => ({ ...prev, ...form, initialState: { ...prev.initialState, ...updatedInitialState, }, }));
      }
    } else if (dataField === "UENNumber") {
      const updatedInitialState = {
        ...form.initialState,
        [dataField]: value,
      };
      setFormData((prev) => {
        const updatedFormFields = prev.formFields.map((field) =>
          field.id === "validateUEN" ? {
            ...field,
            additionalComponent: (
              <ButtonforValidate
                isDisable={value == companyUEN}
                clickEvent={handleClickValidate}
              />
            ),
          }
            : field
        );
        return {
          ...prev,
          ...form,
          initialState: {
            ...prev.initialState,
            ...updatedInitialState,
          },
          formFields: updatedFormFields,
        };
      });
    } else if (dataField === "organisationLogo" && value) {
      handleOrganazationImageUpload(value);
      const updatedInitialState = {
        ...form.initialState,
        organisationLogo: value?.fileName,
      }
      setFormData((prev) => ({ ...prev, ...form, initialState: { ...prev.initialState, ...updatedInitialState, }, }));
    } else if (dataField === "mailingAddresssameasBusinessAddress") {
      if (value == true) {
        const updatedInitialState = {
          ...form.initialState,
          mailAddressLine1: form.initialState.businessAddressLine1,
          mailAddressLine2: form.initialState.businessAddressLine2,
          mailAddressLine3: form.initialState.businessAddressLine3,
          mailAddressCountry: form.initialState.businessAddressCountry?.value ? form.initialState.businessAddressCountry?.value :form.initialState.businessAddressCountry,
          mailPostalCode: form.initialState.businessPostalCode,
          mailingAddresssameasBusinessAddress: true,
        };
        setFormData((prev) => ({ ...prev, ...form, initialState: { ...prev.initialState, ...updatedInitialState, }, }));
      } else if (value == false) {
        const updatedInitialState = {
          ...form.initialState,
          mailAddressLine1: "",
          mailAddressLine2: "",
          mailAddressLine3: "",
          mailAddressCountry: "",
          mailPostalCode: "",
          mailingAddresssameasBusinessAddress: false,
        };
        setFormData((prev) => ({ ...prev, ...form, initialState: { ...prev.initialState, ...updatedInitialState, }, }));
      }
    } else if (dataField === "billingDetailssameasBusinessAddress") {
      if (value == true) {
        const updatedInitialState = {
          ...form.initialState,
          billingAddressLine1: form.initialState.businessAddressLine1,
          billingAddressLine2: form.initialState.businessAddressLine2,
          billingAddressLine3: form.initialState.businessAddressLine3,
          billingAddressCountry: form.initialState.businessAddressCountry?.value ? form.initialState.businessAddressCountry?.value :form.initialState.businessAddressCountry,
          billingPostalCode: form.initialState.businessPostalCode,
          billingDetailssameasBusinessAddress: true
        };
        setFormData((prev) => ({ ...prev, ...form, initialState: { ...prev.initialState, ...updatedInitialState, }, }));
      } else if (value == false) {
        const updatedInitialState = {
          ...form.initialState,
          billingAddressLine1: "",
          billingAddressLine2: "",
          billingAddressLine3: "",
          billingAddressCountry: "",
          billingPostalCode: "",
          billingDetailssameasBusinessAddress: false
        };
        setFormData((prev) => ({ ...prev, ...form, initialState: { ...prev.initialState, ...updatedInitialState, }, }));
      }
    }
    else if (dataField === "companyisGovernmentAgency") {
      const isGov = value === "yes";
      if (isGov) {
        const newFormData = showGovernmentAgencyFields(form);
        setFormData((prev) => ({
          ...prev,
          ...newFormData,
          initialState: {
            ...prev.initialState,
            ...newFormData.initialState,
            companyisGovernmentAgency: "yes"
          },
        }));
      }
      else {
        const newFormData = hideGovernmentAgencyFields(form);
        const clearedInitialState = {
          ...newFormData.initialState,
          nameofMinistry: "",
          department: "",
          businessUnit: "",
          billingName: "",
          billingNumber: "",
          companyisGovernmentAgency: "no",
          billingNumberId: "",
          billingNameId: "",
        };

        setFormData((prev) => ({
          ...prev,
          ...newFormData,
          initialState: {
            ...prev.initialState,
            ...clearedInitialState,
          },
        }));
      }
    }
    else if (dataField == "areyouaPSPCListedOrganisation") {
      let updatedFormData = {
        ...form, initialState: {
          ...form.initialState, areyouaPSPCListedOrganisation: value,
          pspcListedOrganisation: value === "yes" ? form.initialState.pspcListedOrganisation : ""
        },
        formFields: form.formFields.map((field) => {
          if (field.id === "pspcListedOrganisation") {
            return {
              ...field, style: { containerCss: value === "yes" ? "col-lg-5 mb-2 no-star" : "col-lg-5 mb-2 no-star d-none" },
              validation: value === "yes" ? [{ type: "require" }] : []
            };
          }
          return field;
        })
      };

      setFormData(updatedFormData);
      return;
    }
    else {
      setFormData((prev) => ({ ...prev, ...form, initialState: { ...prev.initialState, ...form.initialState, [dataField]: value, }, }));
    }
  }

  const handleSubmit = () => {
    const formData1 = ref.current.getFormData();
    if ( !formData1 ) { 
        error( "Please fill in all mandatory fields to continue.", "" )
        return;
    }
    let req = {
      SGBCCorporateMemberId: props.id,
      TypeOfCompany: formData1?.typeofCompany?.value ? formData1?.typeofCompany?.value : formData1?.typeofCompany || null,
      RegisteredCompanyName: formData1?.registeredCompanyName || null,
      CompanyUEN: formData1?.UENNumber || null,
      CompanyLogoName: profileImageUpload?.uploadedFileName || null,
      CompanyLogoNameFilePath: profileImageUpload?.fileName || null,
      CountryId: formData1?.country?.value ? formData1?.country?.value : formData1?.country || null,
      MainPhoneNumberCountryId: formData1?.mainPhoneNumberId?.value ? formData1?.mainPhoneNumberId?.value : formData1?.mainPhoneNumberId || null,
      MainPhoneNumber: formData1?.mainPhoneNumber || null,
      GeneralEmail: formData1?.generalEmail || null,
      Website: formData1?.website || null,
      BusinessAddressLine1: formData1?.businessAddressLine1 || null,
      BusinessAddressLine2: formData1?.businessAddressLine2 || null,
      BusinessAddressLine3: formData1?.businessAddressLine3 || null,
      BusinessAddressCountryId: formData1?.businessAddressCountry?.value ? formData1?.businessAddressCountry?.value : formData1?.businessAddressCountry || null,
      BusinessPostalCode: formData1?.businessPostalCode || null,
      MailingAddressLine1: formData1?.mailAddressLine1 || null,
      MailingAddressLine2: formData1?.mailAddressLine2 || null,
      MailingAddressLine3: formData1?.mailAddressLine3 || null,
      MailingAddressCountryId: formData1?.mailingAddresssameasBusinessAddress === true ? (formData1?.businessAddressCountry?.value ?? formData1?.businessAddressCountry ?? null) : formData1?.mailingAddresssameasBusinessAddress === false ? (formData1?.mailAddressCountry?.value ?? formData1?.mailAddressCountry ?? null) : null,
      MailingPostalCode: formData1?.mailPostalCode || null,
      BillingCompanyName: formData1?.billingCompanyName || null,
      BillingContactPerson: formData1?.billingContactPerson || null,
      BillingContactNumberCountryId: formData1?.billingContactNumberId?.value ? formData1?.billingContactNumberId?.value : formData1?.billingContactNumberId || null,
      BillingContactNumber: formData1?.billingContactNumber || null,
      BillingContactEmail: formData1?.billingContactEmail || null,
      BillingAddressLine1: formData1?.billingAddressLine1 || null,
      BillingAddressLine2: formData1?.billingAddressLine2 || null,
      BillingAddressLine3: formData1?.billingAddressLine3 || null,
      BillingAddressCountryId: formData1?.billingDetailssameasBusinessAddress === true ? (formData1?.businessAddressCountry?.value ?? formData1?.businessAddressCountry ?? null) : formData1?.billingDetailssameasBusinessAddress === false ? (formData1?.billingAddressCountry?.value ?? formData1?.billingAddressCountry ?? null) : null,
      BillingPostalCode: formData1?.billingPostalCode || null,
      IsGovernmentAgency: formData1?.companyisGovernmentAgency == "yes" ? true : false || null,
      NameofMinistryORStatutoryBoard: formData1?.nameofMinistry || null,
      Department: formData1?.department || null,
      SubBusinessUnit: formData1?.businessUnit || null,
      ContactNumberforBillingCountryId: formData1?.billingNumberId?.value ? formData1?.billingNumberId?.value : formData1?.billingNumberId || null,
      ContactNumberforBilling: formData1?.billingNumber || null,
      ContactNameforBillingSalutationId: formData1?.billingNameId?.value ? formData1?.billingNameId?.value : formData1?.billingNameId || null,
      ContactNameforBilling: formData1?.billingName || null,
      IsBillingDetailssameasBusinessAddress: formData1?.billingDetailssameasBusinessAddress || false,
      IsMailingAddresssameasBusinessAddress: formData1?.mailingAddresssameasBusinessAddress || false,
      IsPSPCListedOrg: formData1?.areyouaPSPCListedOrganisation === "yes" ? true : false,
      PSPCListingCodeId: formData1?.pspcListedOrganisation?.length > 0 ? formData1?.pspcListedOrganisation?.join(',') : null,
      OrganisationProfileId: formData1?.organisationProfile?.value || formData1?.organisationProfile,
      BusinessCategoriesId: formData1?.businessCategories?.value || formData1?.businessCategories
    }
    updateCorporateMemberDetailsByAdmin(req)

  }

  const formActionHandler = {
    VIEW_IMAGE: handleViewImage,
  }

  useEffect(() => {
    if (!updateCorporateMemberLoading && updateCorporateMemberData) {
      if(updateCorporateMemberData?.errorMessage==='Company UEN Already Exists') {
        ToastService.error("Company UEN Already Exists");
      }
      else{
        ToastService.success(updateCorporateMemberData.errorMessage);
      }
    }
  }, [updateCorporateMemberLoading, updateCorporateMemberData,]);

  useEffect(() => {
    if (!checkUENNumberExistLoading && checkUENNumberExistData) {
      const isExists = checkUENNumberExistData?.errorMessage?.includes("Company UEN Already Exists");

      // setFormData((prev) => {
      //   const updatedFormFields = prev.formFields.map((field) =>
      //     field.id === "validateUEN"
      //       ? {
      //         ...field,
      //         additionalComponent: (
      //           <Buttons
      //             buttonText="Validate"
      //             buttonTypeClassName="btn success-btn ml-auto"
      //             isDisable={!isExists}
      //             onClick={handleClickValidate}
      //           />
      //         ),
      //       }
      //       : field
      //   );

      //   return {
      //     ...prev,
      //     formFields: updatedFormFields,
      //   };
      // });

      if (isExists) {
        ToastService.error(checkUENNumberExistData.errorMessage);
      } else {
        ToastService.success(checkUENNumberExistData.errorMessage);
      }
    }
  }, [checkUENNumberExistLoading, checkUENNumberExistData]);

  useEffect(() => {
    if (props.corporateMemberDetails) {
      const isGov = props.corporateMemberDetails?.isGovernmentAgency;
      setCompanyUEN(props.corporateMemberDetails?.companyUEN);
      setFormData((prev) => {
        let updatedForm = { ...prev };
        if (isGov === true) {
          updatedForm = showGovernmentAgencyFields(updatedForm);
        } else {
          updatedForm = hideGovernmentAgencyFields(updatedForm);
        }
        return updatedForm;
      });
    }
  }, [props.corporateMemberDetails]);

  useEffect(() => {
    if (props.corporateMemberDetails) {
      const isPSPC = props.corporateMemberDetails?.isPSPCListedOrg;
      setFormData((prev) => {
        let updatedForm = { ...prev };
        if (isPSPC === true) {
          updatedForm = showPSPCFields(updatedForm);
        } else {
          updatedForm = hidePSPCFields(updatedForm);
        }
        return updatedForm;
      });
    }
  }, [props.corporateMemberDetails]);

  return (
    <>
      <Accordion title="Corporate Information" button={false}  >
        <div className="row">
          <FormCreator
            ref={ref}
            {...formData}
            onFormFieldValueChange={handleFormFieldChange}
            onActionChange={formActionHandler}
          />
        </div>
        <div className="btn-right-side">
          <Buttons
            buttonText="Save"
            buttonTypeClassName="success-btn"
            onClick={handleSubmit}
            isLoading={updateCorporateMemberLoading}
          />
        </div>
      </Accordion>

      {isModalOpen &&
        <CenterModel
          modelTitle={'View Image'}
          show={"test"}
          handleClose={openModal}
          onUpload={openModal}
          className={"preview-img-model"}

        >
          <div style={{ width: "550px", height: "550px", overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto" }}>
            <img
              src={`${APIUrl}/Common/getImage?type=CompanyLogo&fileName=${props.corporateMemberDetails?.companyLogoNameFilePath}`}
              alt="Uploaded Image"
              width={"100%"}
              height={"100%"}
            />
          </div>
        </CenterModel>
      }

    </>
  )
})

export default CorporateInformation
